import { useTranslations } from 'next-intl'
import Paragraph from '@/shared/v2/shared/components/Paragraph'
import type { ImportUploadStep } from '../hooks/useImportUpload'
import StepIcon from './StepIcon'

const UPLOAD_STEPS = [
    { key: 'validating', labelKey: 'newImport.steps.validating' },
    { key: 'uploading', labelKey: 'newImport.steps.uploading' },
    { key: 'processing', labelKey: 'newImport.steps.processing' }
] as const satisfies readonly { key: ImportUploadStep; labelKey: string }[]

const stepOrder: ImportUploadStep[] = ['validating', 'uploading', 'processing', 'completed']

const UploadProgressSteps = ({ step }: { step: ImportUploadStep }) => {
    const t = useTranslations('imports')

    const getStepStatus = (stepKey: ImportUploadStep) => {
        const currentIndex = stepOrder.indexOf(step)
        const stepIndex = stepOrder.indexOf(stepKey)
        if (currentIndex > stepIndex) return 'done'
        if (currentIndex === stepIndex) return 'active'
        return 'pending'
    }

    return (
        <div className="grid grid-cols-1 gap-4" data-testid="__import-progress__">
            {UPLOAD_STEPS.map(({ key, labelKey }) => {
                const status = getStepStatus(key)
                return (
                    <div key={key} className="flex items-center gap-3">
                        <StepIcon status={status} />
                        <Paragraph
                            color={status === 'pending' ? 'darkGrey' : undefined}
                            variant={status === 'active' ? 'medium' : undefined}
                        >
                            {t(labelKey)}
                        </Paragraph>
                    </div>
                )
            })}
        </div>
    )
}

export default UploadProgressSteps
